module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTYxMy4zIDE0MC4ybTMwLjEgMTAuOWwwIDBxMzAuMSAxMC45IDE5LjEgNDFsLTI0MC44IDY2MS41cS0xMC45IDMwLjEtNDEgMTkuMWwwIDBxLTMwLjEtMTAuOS0xOS4xLTQxbDI0MC44LTY2MS41cTEwLjktMzAuMSA0MS0xOS4xWiIgZmlsbD0iIzAiIHAtaWQ9IjEzMTMiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Slash-outlined.svg
// module id = C8Sf
// module chunks = 75